import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { EventService } from '../../../../../../../services/event/event.service';
import { UiService } from '../../../../../../../services/ui/ui.service';
import { AdminService } from '../../../../services/admin/admin.service';
import { DiplomaPaperService } from '../../../../services/diploma-paper/diploma-paper.service';
import { HelperService } from '../../../../../../../services/helper/helper.service';

@Component({
  selector: 'app-view-diploma-paper-modal',
  templateUrl: './view-diploma-paper-modal.component.html',
  styleUrls: ['./view-diploma-paper-modal.component.css'],
  providers: [DatePipe, DiplomaPaperService]
})
export class ViewDiplomaPaperModalComponent implements OnInit {

  public paper = null;

  constructor(
    private event: EventService,
    private adminService: AdminService,
    private diplomaPaperService: DiplomaPaperService,
    private ui: UiService,
    private datePipe: DatePipe,
    public helper: HelperService
  ) { }

  ngOnInit() {
    this.event.on('view-diploma-paper-modal', 'viewDiplomaPaperModal', paperId => {
      this.paper = null;
      this.getDiplomaPaperDetails(paperId);

    });
  }

  getDiplomaPaperDetails(paperId) {
    this.ui.loader.show('view-diploma-modal => getDiplomaPaperDetails');
    this.diplomaPaperService.getById(paperId, (err, res) => {
      this.ui.loader.hide('view-diploma-modal => getDiplomaPaperDetails');
      if (err) {
        swal('Error!', 'Something went wrong. Please try again later.', 'error');
      } else {
        // console.log(res);
        this.paper = {
          ...res,
          startDate: this.datePipe.transform(this.helper.validateDate(res.start_date), 'y-MM-d, h:mm a'),
          endDate: this.datePipe.transform(this.helper.validateDate(res.end_date), 'y-MM-d, h:mm a'),
          teachers: res.assign_teacher.map(teacher => teacher.user.name).join(', '),
          documents: res.diploma_paper_files || [],
          videos: res.diploma_paper_video || []
        };
      }
    });
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/view-diploma-paper-modal/view-diploma-paper-modal.component.ts